import $ from 'jquery';

export default class HamburgerMenu {
    handleClick = (e) => {
        const header = $('header nav');
        if (header.hasClass('open')) {
            header.removeClass('open');
        } else {
            header.addClass('open');
        }
    }
}
